(function () {
    'use strict';

    angular.module('app', [
        'app.core',
        'app.layout',
        'app.dashboard',
        'app.admin',
        'app.alerts',
        'app.checklists',
        'app.tasks',
        'app.users',
        'app.dailySetup',
        'app.completions',
        'app.notes',
        'app.legal',
        'app.dailyLogs',
        'app.logTypes',
        'app.promos',
        'app.completionTypes',
        'app.reports',
        'app.filterTypes',
        'app.tenants',
        'app.departments',
        'app.eventDisplay',
        'app.promotionalImages',
        'app.paymentGateways',
        'app.paymentTemplates',
        'app.paymentTransactions',
        'app.opsConfig',
        'app.floorPlans',
        'app.tenantReporting',
        'app.help',
        'app.helpText',
        'app.surveys',
        'chart.js',
        'app.lostAndFound',
        'app.book',
        'signature',
        //'app.community',
        'app.notesReportSchedule',
        'app.categoryIcons',
        'app.iCal'
        
    ]);

})();
